var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 119,
    viewBox: "0 0 360 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.6313,
    cy: 22.4738,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2104,
    cy: 43.5263,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.3154,
    cy: 33.0002,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.3684,
    cy: 1.42109,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 22.4738,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.105,
    cy: 33.0002,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.684,
    cy: 54.0527,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.789,
    cy: 43.5263,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.842,
    cy: 11.9475,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.473,
    cy: 33.0002,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.526316,
    cy: 97.2106,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1049,
    cy: 118.263,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.2104,
    cy: 107.737,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.2631,
    cy: 76.1579,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.895,
    cy: 97.2106,
    r: 0.526316,
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.d6052502e0ece13299bafa97ef2476a6.svg";
export { ForwardRef as ReactComponent };